import { AllessehQuerySortKeyTypes, AllessehQuerySortOrderType } from 'hooks/useAllessehContentQuery';
import { DEFAULT_PRODUCT_VALUE, DEFAULT_SORT_CONFIG } from './shared/configs';

enum SECTION_ENUM {
  LETTERS_TO_EDITORS = 'Letters to the Editors',
  EDITORIALS = 'Editorials',
  COMMENTARY = 'Commentary',
  COLUMNISTS = 'Columnists',
  BEST_OF_WEB = 'Best of the Web Today',
  PEPPER_AND_SALT = 'Pepper & Salt',
  REVIEWS = 'Reviews',
  PODCAST_ALL_THINGS_FEED = 'All Things with Kim Strassel',
  PODCAST_FREE_EXPRESSION_FEED = 'Free Expression',
  PODCAST_POTOMAC_WATCH_FEED = 'WSJ Opinion Potomac Watch',
  VIDEOS = 'Opinion Videos',
  OPINION_DOCS = 'WSJ Opinion Documentaries',
  MORE_IN_OPINION = 'More in Opinion'
}

const COLUMNISTS = {
  ...DEFAULT_SORT_CONFIG,
  query: {
    or: [
      {
        terms: {
          key: 'SectionType',
          value: [
            'Main Street',
            'Business World',
            'Declarations',
            'Global View',
            'Politics & Ideas',
            'Potomac Watch',
            'Political Economics',
            'The Americas',
            'Wonder Land',
            'Upward Mobility',
            'Inside View',
            'East is East',
            'Free Expression',
            'Life Science'
          ]
        }
      }
    ]
  },
  count: 5
};

const LETTERS_TO_EDITORS = {
  ...DEFAULT_SORT_CONFIG,
  query: { or: [{ terms: { key: 'SectionType', value: ['Letters'] } }] },
  count: 5
};

const EDITORIALS = {
  ...DEFAULT_SORT_CONFIG,
  query: { or: [{ terms: { key: 'SectionType', value: ['Review & Outlook (U.S.)'] } }] },
  count: 5
};

const COMMENTARY = {
  ...DEFAULT_SORT_CONFIG,
  query: {
    or: [
      {
        terms: {
          key: 'SectionType',
          value: [
            'Commentary (U.S.)',
            'Commentary NoCo',
            'Cross Country',
            'Extra',
            'Federation Feature',
            'Houses of Worship',
            'Journal Editorial Report',
            'Morning Editorial Report',
            'Notable & Quotable',
            'Opinion',
            'Future View',
            "Publisher's Letter"
          ]
        }
      }
    ]
  },
  count: 5
};

const BEST_OF_WEB = {
  ...DEFAULT_SORT_CONFIG,
  query: { or: [{ terms: { key: 'SectionType', value: ['Best of the Web Today'] } }] },
  count: 5
};

const PEPPER_AND_SALT = {
  ...DEFAULT_SORT_CONFIG,
  query: {
    or: [
      {
        terms: {
          key: 'SectionType',
          value: ['Pepper & Salt']
        }
      }
    ]
  },
  count: 5
};

const REVIEWS = {
  ...DEFAULT_SORT_CONFIG,
  query: {
    and: [
      { term: { key: 'ContentType', value: 'article' } },
      { term: { key: 'Product', value: DEFAULT_PRODUCT_VALUE } },
      { term: { key: 'SectionName', value: 'Arts' } }
    ]
  },
  count: 10
};

const publishedDateSort = {
  sort: [{ key: AllessehQuerySortKeyTypes.PublishedDate, order: AllessehQuerySortOrderType.DESC }]
};

const PODCAST_ALL_THINGS_FEED = {
  ...publishedDateSort,
  query: {
    and: [
      { term: { key: 'Product', value: 'WSJ Opinion Audio' } },
      { terms: { key: 'ColumnName', value: ['All Things with Kim Strassel'] } },
      { term: { key: 'ContentType', value: 'audio' } }
    ],
    not: [{ term: { key: 'DocType', value: '77' } }]
  },
  count: 1
};

const PODCAST_FREE_EXPRESSION_FEED = {
  ...publishedDateSort,
  query: {
    and: [
      { term: { key: 'Product', value: 'WSJ Opinion Audio' } },
      { terms: { key: 'ColumnName', value: ['Free Expression'] } },
      { term: { key: 'ContentType', value: 'audio' } }
    ],
    not: [{ term: { key: 'DocType', value: '77' } }]
  },
  count: 1
};

const PODCAST_POTOMAC_WATCH_FEED = {
  ...publishedDateSort,
  query: {
    and: [
      { term: { key: 'Product', value: 'WSJ Opinion Audio' } },
      { terms: { key: 'ColumnName', value: ['WSJ Opinion Potomac Watch'] } },
      { term: { key: 'ContentType', value: 'audio' } }
    ],
    not: [{ term: { key: 'DocType', value: '77' } }]
  },
  count: 1
};

const VIDEOS = {
  ...DEFAULT_SORT_CONFIG,
  query: {
    and: [
      { term: { key: 'ContentType', value: 'video' } },
      { term: { key: 'Product', value: 'WSJ Opinion Video' } },
      { term: { key: 'LanguageCode', value: 'en' } }
    ],
    not: [{ term: { key: 'ColumnName', value: 'WSJ Opinion Documentaries' } }]
  },
  count: 5
};

const OPINION_DOCS = {
  ...DEFAULT_SORT_CONFIG,
  query: {
    and: [
      { term: { key: 'ContentType', value: 'video' } },
      { term: { key: 'Product', value: 'WSJ Opinion Video' } },
      { term: { key: 'ColumnName', value: 'WSJ Opinion Documentaries' } },
      { term: { key: 'LanguageCode', value: 'en' } }
    ]
  },
  count: 5
};

const MORE_IN_OPINION = {
  ...DEFAULT_SORT_CONFIG,
  query: {
    and: [
      { term: { key: 'Product', value: DEFAULT_PRODUCT_VALUE } },
      { term: { key: 'SectionName', value: 'Opinion' } }
    ]
  },
  count: 5
};

export {
  SECTION_ENUM,
  COLUMNISTS,
  LETTERS_TO_EDITORS,
  EDITORIALS,
  COMMENTARY,
  BEST_OF_WEB,
  PEPPER_AND_SALT,
  REVIEWS,
  PODCAST_ALL_THINGS_FEED,
  PODCAST_FREE_EXPRESSION_FEED,
  PODCAST_POTOMAC_WATCH_FEED,
  VIDEOS,
  OPINION_DOCS,
  MORE_IN_OPINION
};
